// Plural Actions
export const GET_MW_PRODUCTS = "GET_MW_PRODUCTS";
export const getMWProducts = (opts = {}) => {
  const params = opts.refresh ? { refresh: "true" } : {};
  const request = axios.get("/moneyworks/products.json", { params });
  return {
    type: GET_MW_PRODUCTS,
    payload: request,
  };
};
